<template>
  <div class="d-flex justify-space-between align-start mb-10">
    <img alt="Logo" :src="logoPath" :width="logoWidth" crossorigin="anonymous" />
    <div class="d-flex flex-column text-right">
      <div class="body3 text--semitransparent">
        {{ $t("reports.executiveSummaryReport.generatedOn") }} {{ generatedOn }}
      </div>
      <div class="body3 text--semitransparent">
        {{ $t("reports.executiveSummaryReport.version") }} {{ version }}
      </div>
    </div>
  </div>
  <v-chip
    class="px-2 py-1 mb-3"
    label
    rounded="3"
    color="indigo-faint"
    variant="flat"
    density="compact"
  >
    <span class="coro-label text-uppercase report-info-chip-label">{{ workplace }}</span>
  </v-chip>
  <div class="mb-14">
    <div class="headline5 mb-1">
      {{ title ?? $t("reports.warningOnlyEmailEventsReport.title") }}
    </div>
    <div class="body2 mb-2">
      {{ selectedDateRange }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import moment from "moment";

const props = withDefaults(
  defineProps<{
    workplace: string;
    selectedDateRange: string;
    logoPath: string;
    version: string;
    title?: string;
    logoWidth?: number;
  }>(),
  {
    title: undefined,
    logoWidth: 56,
  }
);

const generatedOn = computed(() => moment(props.version, "YYYYMMDD_HHmmss").format("L LT"));
</script>

<style scoped lang="scss">
.report-info-chip-label {
  font-size: 14px;
}
</style>
